import axios from "axios";

const apiConfig = {
  getVimeo: async (path, opts) => axios.get(`https://api.logilab.world/api/vimeo${path}`, opts),
};

export default apiConfig;
